import Button from "@components/Button";
import {
    useMarkCurrentChangeAsSeen,
    useCurrentRapidData,
    useUser,
    useModelChangeLoading
} from "@/store";

interface LooksGoodButtonProps {
    /** When true, hides the button (single model mode has no comparison to acknowledge) */
    isSingleModel?: boolean;
    /** Called after marking the change as seen to navigate back */
    onBack?: () => void;
}

export function LooksGoodButton({ isSingleModel = false, onBack }: LooksGoodButtonProps) {
    const markAsSeen = useMarkCurrentChangeAsSeen();
    const rapidData = useCurrentRapidData();
    const user = useUser();
    const loading = useModelChangeLoading();

    const handleLooksGood = async () => {
        if (!rapidData?.id || !user?.uid) return;
        await markAsSeen(rapidData.id, user.uid);
        onBack?.();
    };

    if (isSingleModel) {
        return null;
    }

    return (
        <Button
            type="primary"
            onClick={handleLooksGood}
            disabled={loading || !rapidData?.id}
            className="w-full"
        >
            <i className="far fa-check" />
            <span>{loading ? "Saving..." : "Looks Good"}</span>
        </Button>
    );
}
